var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./AwardsADGWinnersList.jinja');
require('./AwardsADGWinnersList.less');

var CommonVideoPlayer = require('front/components/CommonVideoPlayer/CommonVideoPlayer');


module.exports = Base.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonVideoPlayer': {selector: '.CommonVideoPlayer', viewConstructor: CommonVideoPlayer}
    },


    events: {
        'click .AwardsADGWinnersList-filmHead': 'toggleFilm'
    },


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    },



    toggleFilm: function (e) {
        var $film = $(e.currentTarget).closest('.AwardsADGWinnersList-film');
        var rolledClass = '.AwardsADGWinnersList-filmRolled';
        var activeModifier = 'AwardsADGWinnersList-film--active';

        if ($film.hasClass('AwardsADGWinnersList-film--empty')) return;

        if ($film.hasClass(activeModifier)) {
            $film.find(rolledClass).slideUp(200);
            $film.removeClass(activeModifier);

            $film.find('.CommonVideoPlayer').trigger('pauseplayer');
        } else {
            $film.find(rolledClass).slideDown(200);
            $film.addClass(activeModifier);

            setTimeout(function () {
                $film.find('.CommonVideoPlayer').trigger('initplayer');
            }.bind(this), 250);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/AwardsADGWinnersList/AwardsADGWinnersList.js
// module id = 61
// module chunks = 0